var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlungerLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99902 512.526H852.393L851.202 618.763L755.636 575.727L646.19 623.88L558.95 582.649L452.677 648.558L321.817 682.265L238.147 634.112L203.648 591.376L122.356 626.588L102.133 582.649L26.79 563.688L2.99902 512.526Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99902 512.526H852.393L851.202 618.763L755.636 575.727L646.19 623.88L558.95 582.649L452.677 648.558L321.817 682.265L238.147 634.112L203.648 591.376L122.356 626.588L102.133 582.649L26.79 563.688L2.99902 512.526Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.264 625.785H177.706V739.144H227.264V625.785Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 597.716V740.065H228.191L228.4 585.533",
    fill: "#131F2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 597.716V740.065H228.191L228.4 585.533",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 597.716V740.065H228.191L228.4 585.533",
    fill: "#131F2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 597.716V740.065H228.191L228.4 585.533",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.879 599.803L237.094 583.946",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.879 599.803L237.094 583.946",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 734.333L131.961 731.122L176.903 728.514",
    fill: "#131F2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 734.333L131.961 731.122L176.903 728.514",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 734.333L131.961 731.122L176.903 728.514",
    fill: "#131F2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 734.333L131.961 731.122L176.903 728.514",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 719.133L131.76 716.524L176.903 713.314",
    fill: "#131F2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 719.133L131.76 716.524L176.903 713.314",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 719.133L131.76 716.524L176.903 713.314",
    fill: "#131F2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 719.133L131.76 716.524L176.903 713.314",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M227.866 712.36L271.804 715.972L227.84 719.383",
    fill: "#131F2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M227.866 712.36L271.804 715.972L227.84 719.383",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M227.866 712.36L271.804 715.972L227.84 719.383",
    fill: "#131F2E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M227.866 712.36L271.804 715.972L227.84 719.383",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.169 727.864L271.908 732.278L227.994 735.088",
    fill: "#131F2E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M228.169 727.864L271.908 732.278L227.994 735.088",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M228.169 727.864L271.908 732.278L227.994 735.088",
    fill: "#131F2E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M228.169 727.864L271.908 732.278L227.994 735.088",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M176.602 590.423V510.971H227.012V579.37",
    fill: "#131F2E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.602 590.423V510.971H227.012V579.37",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M176.602 590.423V510.971H227.012V579.37",
    fill: "#131F2E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M176.602 590.423V510.971H227.012V579.37",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M176.823 511.768L176.749 526.771L226.631 518.721V511.617L176.823 511.768Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M176.823 511.768L176.749 526.771L226.631 518.721V511.617L176.823 511.768Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M185.405 540.163V526.018L218.435 520.526V534.897L185.405 540.163Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M185.405 540.163V526.018L218.435 520.526V534.897L185.405 540.163Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M218.435 534.395V581.144",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M218.435 534.395V581.144",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M509.158 456.407H77.3879V470.141H509.158V456.407Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M509.158 456.407H77.3879V470.141H509.158V456.407Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M233.257 195.251H173.066V200.066H233.257V195.251Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M233.257 195.251H173.066V200.066H233.257V195.251Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M207.714 144H198.685V350.562H207.714V144Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M207.714 144H198.685V350.562H207.714V144Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M211.514 348.906H194.961V400.068H211.514V348.906Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M211.514 348.906H194.961V400.068H211.514V348.906Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M221.897 398.263H185.18V417.825H221.897V398.263Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M221.897 398.263H185.18V417.825H221.897V398.263Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M235.891 497.076H167.875V506.105H235.891V497.076Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M235.891 497.076H167.875V506.105H235.891V497.076Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M239.352 504.35H164.113V512.476H239.352V504.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M239.352 504.35H164.113V512.476H239.352V504.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M229.721 441.75H176.753V496.975H229.721V441.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M229.721 441.75H176.753V496.975H229.721V441.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M174.345 446.465H168.928V449.625H174.345V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.345 446.465H168.928V449.625H174.345V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 446.465H176.753V449.625H182.17V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 446.465H176.753V449.625H182.17V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M189.995 446.465H184.578V449.625H189.995V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M189.995 446.465H184.578V449.625H189.995V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M197.82 446.465H192.403V449.625H197.82V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M197.82 446.465H192.403V449.625H197.82V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M205.644 446.465H200.227V449.625H205.644V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M205.644 446.465H200.227V449.625H205.644V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M213.469 446.465H208.052V449.625H213.469V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M213.469 446.465H208.052V449.625H213.469V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M221.294 446.465H215.877V449.625H221.294V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M221.294 446.465H215.877V449.625H221.294V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 446.465H223.702V449.625H229.119V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 446.465H223.702V449.625H229.119V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 446.465H231.527V449.625H236.944V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 446.465H231.527V449.625H236.944V446.465Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M241.91 414.915H164.113V446.867H241.91V414.915Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M241.91 414.915H164.113V446.867H241.91V414.915Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M174.345 412.006H168.928V415.166H174.345V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M174.345 412.006H168.928V415.166H174.345V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 412.006H176.753V415.166H182.17V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 412.006H176.753V415.166H182.17V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M189.995 412.006H184.578V415.166H189.995V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M189.995 412.006H184.578V415.166H189.995V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M197.82 412.006H192.403V415.166H197.82V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M197.82 412.006H192.403V415.166H197.82V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M205.644 412.006H200.227V415.166H205.644V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M205.644 412.006H200.227V415.166H205.644V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M213.469 412.006H208.052V415.166H213.469V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M213.469 412.006H208.052V415.166H213.469V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M221.294 412.006H215.877V415.166H221.294V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M221.294 412.006H215.877V415.166H221.294V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 412.006H223.702V415.166H229.119V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 412.006H223.702V415.166H229.119V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 412.006H231.527V415.166H236.944V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 412.006H231.527V415.166H236.944V412.006Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.75
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M202.71 441.902C204.746 441.902 206.397 440.251 206.397 438.215C206.397 436.179 204.746 434.528 202.71 434.528C200.674 434.528 199.023 436.179 199.023 438.215C199.023 440.251 200.674 441.902 202.71 441.902Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M164.113 430.616H241.91",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M755.565 314.146L771.215 301.731L218.536 301.556L218.435 314.396L755.565 314.146Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M755.565 314.146L771.215 301.731L218.536 301.556L218.435 314.396L755.565 314.146Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M450.246 299.474H436.778V317.381H450.246V299.474Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M450.246 299.474H436.778V317.381H450.246V299.474Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M446.333 295.411H440.841V320.766H446.333V295.411Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M446.333 295.411H440.841V320.766H446.333V295.411Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M531.429 299.474H498.399V317.381H531.429V299.474Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M531.429 299.474H498.399V317.381H531.429V299.474Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M211.514 291.524H194.961V325.331H211.514V291.524Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M211.514 291.524H194.961V325.331H211.514V291.524Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M211.614 300.202L207.751 307.525L211.614 315.6L219.438 315.751L219.588 300.251L211.614 300.202Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M211.614 300.202L207.751 307.525L211.614 315.6L219.438 315.751L219.588 300.251L211.614 300.202Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M152.903 453.999H107.985V472.9H152.903V453.999Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M152.903 453.999H107.985V472.9H152.903V453.999Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M289.235 453.999H244.317V472.9H289.235V453.999Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M289.235 453.999H244.317V472.9H289.235V453.999Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M168.627 592.118L236.041 576.669",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M168.627 592.118L236.041 576.669",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M467.986 453.477H440.148V472.378H467.986V453.477Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M467.986 453.477H440.148V472.378H467.986V453.477Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M459.109 451.772H449.177V474.084H459.109V451.772Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M459.109 451.772H449.177V474.084H459.109V451.772Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M533.547 399.949C535.521 426.948 523.312 460.251 512.779 468.466L511.575 469.67C498.111 486.212 475.072 479.74 459.45 471.661",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M296.555 269.125C296.485 273.818 299.327 300.199 337.648 301.626",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M502.145 399.448C501.207 417.517 510.172 423.925 519.201 444.19L502.145 399.448Z",
    fill: "#131F2E"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M502.145 399.448C501.207 417.517 510.172 423.925 519.201 444.19",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M515.688 332.335C509.933 323.085 501.105 317.337 489.507 314.177L515.688 332.335Z",
    fill: "#131F2E"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M515.688 332.335C509.933 323.085 501.105 317.337 489.507 314.177",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M524.367 321.4H514.258V509.798H524.367V321.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M524.367 321.4H514.258V509.798H524.367V321.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M525.873 503.176H512.754V512.807H525.873V503.176Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M525.873 503.176H512.754V512.807H525.873V503.176Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M518.198 454.723H508.718V471.727H518.198V454.723Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M518.198 454.723H508.718V471.727H518.198V454.723Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M526.022 452.917H512.329V473.231H526.022V452.917Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M526.022 452.917H512.329V473.231H526.022V452.917Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M528.229 316.083H510.623V325.061H528.229V316.083Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M528.229 316.083H510.623V325.061H528.229V316.083Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M552.908 331.833H485.695V400.451H552.908V331.833Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M552.908 331.833H485.695V400.451H552.908V331.833Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M549.296 334.642H488.903V397.441H549.296V334.642Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M549.296 334.642H488.903V397.441H549.296V334.642Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M550.411 323.095H533.758V331.121H550.411V323.095Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M550.411 323.095H533.758V331.121H550.411V323.095Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M547 193.745H537.169V323.095H547V193.745Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M547 193.745H537.169V323.095H547V193.745Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M550.411 181.632H533.758V193.745H550.411V181.632Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M550.411 181.632H533.758V193.745H550.411V181.632Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M550.164 187.275H589.431",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M550.164 187.275H589.431",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M553.775 163.825V209.069",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M553.775 163.825V209.069",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M560.672 168.766V206.021",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M560.672 168.766V206.021",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M567.142 172.001V201.571",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M567.142 172.001V201.571",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M572.56 177.719V197.658",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M572.56 177.719V197.658",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M579.03 181.632V193.105",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M579.03 181.632V193.105",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M585.501 183.513V191.04",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M585.501 183.513V191.04",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M420.881 454.048H398.911V472.949H420.881V454.048Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M420.881 454.048H398.911V472.949H420.881V454.048Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M422.385 452.344H408.341V474.656H422.385V452.344Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M422.385 452.344H408.341V474.656H422.385V452.344Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M422.386 451.64H413.859V475.458H422.386V451.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M422.386 451.64H413.859V475.458H422.386V451.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M422.386 450.036H415.465V476.862H422.386V450.036Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M422.386 450.036H415.465V476.862H422.386V450.036Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M266.813 481.304C276.453 481.304 284.268 473.489 284.268 463.849C284.268 454.209 276.453 446.394 266.813 446.394C257.173 446.394 249.358 454.209 249.358 463.849C249.358 473.489 257.173 481.304 266.813 481.304Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M266.813 481.304C276.453 481.304 284.268 473.489 284.268 463.849C284.268 454.209 276.453 446.394 266.813 446.394C257.173 446.394 249.358 454.209 249.358 463.849C249.358 473.489 257.173 481.304 266.813 481.304Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M266.813 473.028C271.384 473.028 275.089 469.323 275.089 464.752C275.089 460.181 271.384 456.476 266.813 456.476C262.242 456.476 258.537 460.181 258.537 464.752C258.537 469.323 262.242 473.028 266.813 473.028Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M266.813 473.028C271.384 473.028 275.089 469.323 275.089 464.752C275.089 460.181 271.384 456.476 266.813 456.476C262.242 456.476 258.537 460.181 258.537 464.752C258.537 469.323 262.242 473.028 266.813 473.028Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M270.574 455.723C272.319 455.723 273.734 454.308 273.734 452.563C273.734 450.818 272.319 449.403 270.574 449.403C268.829 449.403 267.414 450.818 267.414 452.563C267.414 454.308 268.829 455.723 270.574 455.723Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M270.574 455.723C272.319 455.723 273.734 454.308 273.734 452.563C273.734 450.818 272.319 449.403 270.574 449.403C268.829 449.403 267.414 450.818 267.414 452.563C267.414 454.308 268.829 455.723 270.574 455.723Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M276.744 460.538C278.489 460.538 279.904 459.123 279.904 457.378C279.904 455.633 278.489 454.218 276.744 454.218C274.999 454.218 273.584 455.633 273.584 457.378C273.584 459.123 274.999 460.538 276.744 460.538Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M276.744 460.538C278.489 460.538 279.904 459.123 279.904 457.378C279.904 455.633 278.489 454.218 276.744 454.218C274.999 454.218 273.584 455.633 273.584 457.378C273.584 459.123 274.999 460.538 276.744 460.538Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M279.152 467.46C280.897 467.46 282.312 466.045 282.312 464.3C282.312 462.555 280.897 461.14 279.152 461.14C277.407 461.14 275.992 462.555 275.992 464.3C275.992 466.045 277.407 467.46 279.152 467.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M279.152 467.46C280.897 467.46 282.312 466.045 282.312 464.3C282.312 462.555 280.897 461.14 279.152 461.14C277.407 461.14 275.992 462.555 275.992 464.3C275.992 466.045 277.407 467.46 279.152 467.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M276.744 474.382C278.489 474.382 279.904 472.967 279.904 471.222C279.904 469.477 278.489 468.062 276.744 468.062C274.999 468.062 273.584 469.477 273.584 471.222C273.584 472.967 274.999 474.382 276.744 474.382Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M276.744 474.382C278.489 474.382 279.904 472.967 279.904 471.222C279.904 469.477 278.489 468.062 276.744 468.062C274.999 468.062 273.584 469.477 273.584 471.222C273.584 472.967 274.999 474.382 276.744 474.382Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M270.875 479.047C272.62 479.047 274.035 477.632 274.035 475.887C274.035 474.142 272.62 472.727 270.875 472.727C269.13 472.727 267.715 474.142 267.715 475.887C267.715 477.632 269.13 479.047 270.875 479.047Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M270.875 479.047C272.62 479.047 274.035 477.632 274.035 475.887C274.035 474.142 272.62 472.727 270.875 472.727C269.13 472.727 267.715 474.142 267.715 475.887C267.715 477.632 269.13 479.047 270.875 479.047Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9 479.047C264.645 479.047 266.06 477.632 266.06 475.887C266.06 474.142 264.645 472.727 262.9 472.727C261.155 472.727 259.74 474.142 259.74 475.887C259.74 477.632 261.155 479.047 262.9 479.047Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9 479.047C264.645 479.047 266.06 477.632 266.06 475.887C266.06 474.142 264.645 472.727 262.9 472.727C261.155 472.727 259.74 474.142 259.74 475.887C259.74 477.632 261.155 479.047 262.9 479.047Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M256.881 474.683C258.626 474.683 260.041 473.268 260.041 471.523C260.041 469.778 258.626 468.363 256.881 468.363C255.136 468.363 253.721 469.778 253.721 471.523C253.721 473.268 255.136 474.683 256.881 474.683Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M256.881 474.683C258.626 474.683 260.041 473.268 260.041 471.523C260.041 469.778 258.626 468.363 256.881 468.363C255.136 468.363 253.721 469.778 253.721 471.523C253.721 473.268 255.136 474.683 256.881 474.683Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M254.323 467.611C256.068 467.611 257.483 466.196 257.483 464.451C257.483 462.706 256.068 461.291 254.323 461.291C252.578 461.291 251.163 462.706 251.163 464.451C251.163 466.196 252.578 467.611 254.323 467.611Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M254.323 467.611C256.068 467.611 257.483 466.196 257.483 464.451C257.483 462.706 256.068 461.291 254.323 461.291C252.578 461.291 251.163 462.706 251.163 464.451C251.163 466.196 252.578 467.611 254.323 467.611Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M256.58 460.388C258.325 460.388 259.74 458.973 259.74 457.228C259.74 455.483 258.325 454.068 256.58 454.068C254.835 454.068 253.42 455.483 253.42 457.228C253.42 458.973 254.835 460.388 256.58 460.388Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M256.58 460.388C258.325 460.388 259.74 458.973 259.74 457.228C259.74 455.483 258.325 454.068 256.58 454.068C254.835 454.068 253.42 455.483 253.42 457.228C253.42 458.973 254.835 460.388 256.58 460.388Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9 455.723C264.645 455.723 266.06 454.308 266.06 452.563C266.06 450.818 264.645 449.403 262.9 449.403C261.155 449.403 259.74 450.818 259.74 452.563C259.74 454.308 261.155 455.723 262.9 455.723Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9 455.723C264.645 455.723 266.06 454.308 266.06 452.563C266.06 450.818 264.645 449.403 262.9 449.403C261.155 449.403 259.74 450.818 259.74 452.563C259.74 454.308 261.155 455.723 262.9 455.723Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M266.776 489.532C281.181 489.532 292.859 477.854 292.859 463.449C292.859 449.044 281.181 437.366 266.776 437.366C252.371 437.366 240.693 449.044 240.693 463.449C240.693 477.854 252.371 489.532 266.776 489.532Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 6
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M262.068 437.593L267.299 465.402",
    stroke: "#F7F9F9",
    strokeWidth: 6
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M266.988 463.8L247.848 479.093",
    stroke: "#F7F9F9",
    strokeWidth: 6
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M266.72 464.048L291.568 474.519",
    stroke: "#F7F9F9",
    strokeWidth: 6
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M369.629 453.231H335.32V472.133H369.629V453.231Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M369.629 453.231H335.32V472.133H369.629V453.231Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M344.714 445.836V454.563L353.04 457.949L361.342 454.488V445.848L344.714 445.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M344.714 445.836V454.563L353.04 457.949L361.342 454.488V445.848L344.714 445.836Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M711.486 299.845H701.254V304.159H711.486V299.845Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M711.486 299.845H701.254V304.159H711.486V299.845Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M728.137 299.845H717.905V304.159H728.137V299.845Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M728.137 299.845H717.905V304.159H728.137V299.845Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M709.682 292.117H702.86V301.05H709.682V292.117Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M709.682 292.117H702.86V301.05H709.682V292.117Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M726.532 292.117H719.71V300.845H726.532V292.117Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M726.532 292.117H719.71V300.845H726.532V292.117Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M729.742 288.108H699.448V293.726H729.742V288.108Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M729.742 288.108H699.448V293.726H729.742V288.108Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M728.136 273.663H701.254V289.108H728.136V273.663Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M728.136 273.663H701.254V289.108H728.136V273.663Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M715.199 273.663C726.003 273.663 734.761 264.905 734.761 254.101C734.761 243.297 726.003 234.539 715.199 234.539C704.395 234.539 695.637 243.297 695.637 254.101C695.637 264.905 704.395 273.663 715.199 273.663Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M715.199 273.663C726.003 273.663 734.761 264.905 734.761 254.101C734.761 243.297 726.003 234.539 715.199 234.539C704.395 234.539 695.637 243.297 695.637 254.101C695.637 264.905 704.395 273.663 715.199 273.663Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M715.148 236.292C725.01 236.292 733.004 244.287 733.004 254.149C733.004 264.011 725.009 272.006 715.148 272.006C705.286 272.006 697.291 264.011 697.291 254.149C697.291 244.287 705.286 236.292 715.148 236.292Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M715.148 236.292C725.01 236.292 733.004 244.287 733.004 254.149C733.004 264.011 725.009 272.006 715.148 272.006C705.286 272.006 697.291 264.011 697.291 254.149C697.291 244.287 705.286 236.292 715.148 236.292Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M728.739 247.782H701.856V260.623H728.739V247.782Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M728.739 247.782H701.856V260.623H728.739V247.782Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48 478.816C140.12 478.816 147.935 471.001 147.935 461.361C147.935 451.721 140.12 443.906 130.48 443.906C120.84 443.906 113.025 451.721 113.025 461.361C113.025 471.001 120.84 478.816 130.48 478.816Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48 478.816C140.12 478.816 147.935 471.001 147.935 461.361C147.935 451.721 140.12 443.906 130.48 443.906C120.84 443.906 113.025 451.721 113.025 461.361C113.025 471.001 120.84 478.816 130.48 478.816Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48 470.54C135.051 470.54 138.756 466.835 138.756 462.264C138.756 457.693 135.051 453.988 130.48 453.988C125.909 453.988 122.204 457.693 122.204 462.264C122.204 466.835 125.909 470.54 130.48 470.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48 470.54C135.051 470.54 138.756 466.835 138.756 462.264C138.756 457.693 135.051 453.988 130.48 453.988C125.909 453.988 122.204 457.693 122.204 462.264C122.204 466.835 125.909 470.54 130.48 470.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M134.242 453.235C135.987 453.235 137.402 451.82 137.402 450.075C137.402 448.33 135.987 446.915 134.242 446.915C132.497 446.915 131.082 448.33 131.082 450.075C131.082 451.82 132.497 453.235 134.242 453.235Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M134.242 453.235C135.987 453.235 137.402 451.82 137.402 450.075C137.402 448.33 135.987 446.915 134.242 446.915C132.497 446.915 131.082 448.33 131.082 450.075C131.082 451.82 132.497 453.235 134.242 453.235Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M140.411 458.05C142.156 458.05 143.571 456.635 143.571 454.89C143.571 453.145 142.156 451.73 140.411 451.73C138.666 451.73 137.251 453.145 137.251 454.89C137.251 456.635 138.666 458.05 140.411 458.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M140.411 458.05C142.156 458.05 143.571 456.635 143.571 454.89C143.571 453.145 142.156 451.73 140.411 451.73C138.666 451.73 137.251 453.145 137.251 454.89C137.251 456.635 138.666 458.05 140.411 458.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M142.819 464.972C144.564 464.972 145.979 463.557 145.979 461.812C145.979 460.067 144.564 458.652 142.819 458.652C141.074 458.652 139.659 460.067 139.659 461.812C139.659 463.557 141.074 464.972 142.819 464.972Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M142.819 464.972C144.564 464.972 145.979 463.557 145.979 461.812C145.979 460.067 144.564 458.652 142.819 458.652C141.074 458.652 139.659 460.067 139.659 461.812C139.659 463.557 141.074 464.972 142.819 464.972Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M140.411 471.894C142.156 471.894 143.571 470.479 143.571 468.734C143.571 466.989 142.156 465.574 140.411 465.574C138.666 465.574 137.251 466.989 137.251 468.734C137.251 470.479 138.666 471.894 140.411 471.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M140.411 471.894C142.156 471.894 143.571 470.479 143.571 468.734C143.571 466.989 142.156 465.574 140.411 465.574C138.666 465.574 137.251 466.989 137.251 468.734C137.251 470.479 138.666 471.894 140.411 471.894Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M134.543 476.559C136.288 476.559 137.703 475.144 137.703 473.399C137.703 471.654 136.288 470.239 134.543 470.239C132.798 470.239 131.383 471.654 131.383 473.399C131.383 475.144 132.798 476.559 134.543 476.559Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M134.543 476.559C136.288 476.559 137.703 475.144 137.703 473.399C137.703 471.654 136.288 470.239 134.543 470.239C132.798 470.239 131.383 471.654 131.383 473.399C131.383 475.144 132.798 476.559 134.543 476.559Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M126.567 476.559C128.312 476.559 129.727 475.144 129.727 473.399C129.727 471.654 128.312 470.239 126.567 470.239C124.822 470.239 123.407 471.654 123.407 473.399C123.407 475.144 124.822 476.559 126.567 476.559Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M126.567 476.559C128.312 476.559 129.727 475.144 129.727 473.399C129.727 471.654 128.312 470.239 126.567 470.239C124.822 470.239 123.407 471.654 123.407 473.399C123.407 475.144 124.822 476.559 126.567 476.559Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M120.548 472.195C122.293 472.195 123.708 470.78 123.708 469.035C123.708 467.29 122.293 465.875 120.548 465.875C118.803 465.875 117.388 467.29 117.388 469.035C117.388 470.78 118.803 472.195 120.548 472.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M120.548 472.195C122.293 472.195 123.708 470.78 123.708 469.035C123.708 467.29 122.293 465.875 120.548 465.875C118.803 465.875 117.388 467.29 117.388 469.035C117.388 470.78 118.803 472.195 120.548 472.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M117.99 465.123C119.735 465.123 121.15 463.708 121.15 461.963C121.15 460.218 119.735 458.803 117.99 458.803C116.245 458.803 114.83 460.218 114.83 461.963C114.83 463.708 116.245 465.123 117.99 465.123Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M117.99 465.123C119.735 465.123 121.15 463.708 121.15 461.963C121.15 460.218 119.735 458.803 117.99 458.803C116.245 458.803 114.83 460.218 114.83 461.963C114.83 463.708 116.245 465.123 117.99 465.123Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M120.247 457.9C121.992 457.9 123.407 456.485 123.407 454.74C123.407 452.995 121.992 451.58 120.247 451.58C118.502 451.58 117.087 452.995 117.087 454.74C117.087 456.485 118.502 457.9 120.247 457.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M120.247 457.9C121.992 457.9 123.407 456.485 123.407 454.74C123.407 452.995 121.992 451.58 120.247 451.58C118.502 451.58 117.087 452.995 117.087 454.74C117.087 456.485 118.502 457.9 120.247 457.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M126.567 453.235C128.312 453.235 129.727 451.82 129.727 450.075C129.727 448.33 128.312 446.915 126.567 446.915C124.822 446.915 123.407 448.33 123.407 450.075C123.407 451.82 124.822 453.235 126.567 453.235Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M126.567 453.235C128.312 453.235 129.727 451.82 129.727 450.075C129.727 448.33 128.312 446.915 126.567 446.915C124.822 446.915 123.407 448.33 123.407 450.075C123.407 451.82 124.822 453.235 126.567 453.235Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M130.442 487.044C144.847 487.044 156.525 475.366 156.525 460.961C156.525 446.556 144.847 434.878 130.442 434.878C116.037 434.878 104.359 446.556 104.359 460.961C104.359 475.366 116.037 487.044 130.442 487.044Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 6
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M125.772 433.785L130.672 462.943",
    stroke: "#F7F9F9",
    strokeWidth: 6
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M131.086 461.316L111.514 479.18",
    stroke: "#F7F9F9",
    strokeWidth: 6
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M130.842 461.575L153.059 472.443",
    stroke: "#F7F9F9",
    strokeWidth: 6
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M354.595 404.353H351.585V430.891H354.595V404.353Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M354.595 404.353H351.585V430.891H354.595V404.353Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 426.022H354.595",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 426.022H354.595",
    stroke: "#F7F9F9"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 418.427H354.595",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 418.427H354.595",
    stroke: "#F7F9F9"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 410.773H354.595",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 410.773H354.595",
    stroke: "#F7F9F9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 408.646H354.595",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 408.646H354.595",
    stroke: "#F7F9F9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M354.446 398.334C354.446 401.326 353.839 403.751 353.09 403.751C352.341 403.751 351.734 401.326 351.734 398.334C351.734 395.342 352.341 392.917 353.09 392.917C353.839 392.917 354.446 395.342 354.446 398.334Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M354.446 398.334C354.446 401.326 353.839 403.751 353.09 403.751C352.341 403.751 351.734 401.326 351.734 398.334C351.734 395.342 352.341 392.917 353.09 392.917C353.839 392.917 354.446 395.342 354.446 398.334Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 412.608H346.315V411.376C346.315 411.376 342.021 409.852 341.099 410.774C340.283 411.59 339.946 415.336 341.099 415.392C343.707 415.518 351.586 415.518 351.586 415.518",
    fill: "#131F2E"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 412.608H346.315V411.376C346.315 411.376 342.021 409.852 341.099 410.774C340.283 411.59 339.946 415.336 341.099 415.392C343.707 415.518 351.586 415.518 351.586 415.518",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 412.608H346.315V411.376C346.315 411.376 342.021 409.852 341.099 410.774C340.283 411.59 339.946 415.336 341.099 415.392C343.707 415.518 351.586 415.518 351.586 415.518",
    fill: "#131F2E"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 412.608H346.315V411.376C346.315 411.376 342.021 409.852 341.099 410.774C340.283 411.59 339.946 415.336 341.099 415.392C343.707 415.518 351.586 415.518 351.586 415.518",
    stroke: "#F7F9F9"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M348.536 412.608V415.517",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M348.536 412.608V415.517",
    stroke: "#F7F9F9"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M353.09 392.917C351.585 392.112 358.908 397.193 358.908 404.556C358.908 408.151 354.594 416.401 354.595 418.427",
    fill: "#131F2E"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M353.09 392.917C351.585 392.112 358.908 397.193 358.908 404.556C358.908 408.151 354.594 416.401 354.595 418.427",
    stroke: "#F7F9F9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M303.544 298.977H278.526V317.879H303.544V298.977Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M303.544 298.977H278.526V317.879H303.544V298.977Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M282.727 291.716V300.444L291.053 303.83L299.355 300.369V291.728L282.727 291.716Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M282.727 291.716V300.444L291.053 303.83L299.355 300.369V291.728L282.727 291.716Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M284.113 192.752L287.346 192.525L287.93 190.946H294.15L294.944 192.496L297.957 192.752V292.123H284.113V192.752Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M284.113 192.752L287.346 192.525L287.93 190.946H294.15L294.944 192.496L297.957 192.752V292.123H284.113V192.752Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M299.994 261.425H282.087V271.657H299.994V261.425Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M299.994 261.425H282.087V271.657H299.994V261.425Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M302.778 264.736H279.303V268.347H302.778V264.736Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M302.778 264.736H279.303V268.347H302.778V264.736Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M300.486 210.017H281.584V235.035H300.486V210.017Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M300.486 210.017H281.584V235.035H300.486V210.017Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M273.247 230.84H281.974L285.36 222.514L281.899 214.212H273.259L273.247 230.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M273.247 230.84H281.974L285.36 222.514L281.899 214.212H273.259L273.247 230.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M347.168 433.01L349.839 432.981L350.321 431.571H355.459L356.116 432.977L358.605 433.01V445.943H347.168V433.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M347.168 433.01L349.839 432.981L350.321 431.571H355.459L356.116 432.977L358.605 433.01V445.943H347.168V433.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M292.241 164.779H289.231V191.317H292.241V164.779Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M292.241 164.779H289.231V191.317H292.241V164.779Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 186.447H292.241",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 186.447H292.241",
    stroke: "#F7F9F9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 178.852H292.241",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 178.852H292.241",
    stroke: "#F7F9F9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 171.199H292.241",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 171.199H292.241",
    stroke: "#F7F9F9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 169.071H292.241",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 169.071H292.241",
    stroke: "#F7F9F9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M292.092 158.759C292.092 161.751 291.485 164.176 290.736 164.176C289.987 164.176 289.38 161.751 289.38 158.759C289.38 155.767 289.987 153.342 290.736 153.342C291.485 153.342 292.092 155.768 292.092 158.759Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M292.092 158.759C292.092 161.751 291.485 164.176 290.736 164.176C289.987 164.176 289.38 161.751 289.38 158.759C289.38 155.767 289.987 153.342 290.736 153.342C291.485 153.342 292.092 155.768 292.092 158.759Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 173.033H283.961V171.801C283.961 171.801 279.667 170.277 278.745 171.199C277.929 172.015 277.592 175.762 278.745 175.817C281.353 175.943 289.232 175.943 289.232 175.943",
    fill: "#131F2E"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 173.033H283.961V171.801C283.961 171.801 279.667 170.277 278.745 171.199C277.929 172.015 277.592 175.762 278.745 175.817C281.353 175.943 289.232 175.943 289.232 175.943",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 173.033H283.961V171.801C283.961 171.801 279.667 170.277 278.745 171.199C277.929 172.015 277.592 175.762 278.745 175.817C281.353 175.943 289.232 175.943 289.232 175.943",
    fill: "#131F2E"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 173.033H283.961V171.801C283.961 171.801 279.667 170.277 278.745 171.199C277.929 172.015 277.592 175.762 278.745 175.817C281.353 175.943 289.232 175.943 289.232 175.943",
    stroke: "#F7F9F9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M286.182 173.033V175.943",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M286.182 173.033V175.943",
    stroke: "#F7F9F9"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M290.736 153.342C289.231 152.537 296.554 157.618 296.554 164.981C296.554 168.576 292.24 176.826 292.241 178.852",
    fill: "#131F2E"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M290.736 153.342C289.231 152.537 296.554 157.618 296.554 164.981C296.554 168.576 292.24 176.826 292.241 178.852",
    stroke: "#F7F9F9"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M211.401 191.317H194.848V239.43H211.401V191.317Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M211.401 191.317H194.848V239.43H211.401V191.317Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M210.511 214.752L206.648 222.075L210.51 230.15L218.335 230.3L218.485 214.801L210.511 214.752Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M210.511 214.752L206.648 222.075L210.51 230.15L218.335 230.3L218.485 214.801L210.511 214.752Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M273.247 215.659H218.586V229.393H273.247V215.659Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M273.247 215.659H218.586V229.393H273.247V215.659Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M260.644 213.075H232.806V231.976H260.644V213.075Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M260.644 213.075H232.806V231.976H260.644V213.075Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M251.766 211.37H241.834V233.682H251.766V211.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M251.766 211.37H241.834V233.682H251.766V211.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M259.835 298.976H231.997V317.877H259.835V298.976Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M259.835 298.976H231.997V317.877H259.835V298.976Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M250.958 297.272H241.026V319.584H250.958V297.272Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M250.958 297.272H241.026V319.584H250.958V297.272Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M249.311 208.179H245.098V211.189H249.311V208.179Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M247.928 293.606H243.715V296.616H247.928V293.606Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M194.848 201.571H210.761",
    stroke: "#F7F9F9",
    strokeWidth: 4
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M199.024 149.417H208.052",
    stroke: "#F7F9F9",
    strokeWidth: 4
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M386.532 299.7H352.725V316.253H386.532V299.7Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M386.532 299.7H352.725V316.253H386.532V299.7Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M359.095 299.327L369.016 303.19L379.958 299.328L380.162 283.57H359.095V299.327Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M359.095 299.327L369.016 303.19L379.958 299.328L380.162 283.57H359.095V299.327Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M359.095 288.987H380.092",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M359.095 288.987H380.092",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M359.662 284.118C359.662 284.118 352.449 276.276 352.439 262.903C352.426 245.95 359.662 239.429 359.662 239.429H380.729C380.729 239.429 387.35 247.28 387.35 262.903C387.35 277.249 380.729 284.118 380.729 284.118H359.662Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M359.662 284.118C359.662 284.118 352.449 276.276 352.439 262.903C352.426 245.95 359.662 239.429 359.662 239.429H380.729C380.729 239.429 387.35 247.28 387.35 262.903C387.35 277.249 380.729 284.118 380.729 284.118H359.662Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M380.624 201.689H359.557V239.548H380.624V201.689Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M380.624 201.689H359.557V239.548H380.624V201.689Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M331.255 216.626C331.255 216.626 349.203 206.883 371.495 206.883C392.72 206.883 407.982 216.626 407.982 216.626L407.767 218.79L381.109 223.061L369.139 223.348L359.331 222.966L331.203 218.717L331.255 216.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M331.255 216.626C331.255 216.626 349.203 206.883 371.495 206.883C392.72 206.883 407.982 216.626 407.982 216.626L407.767 218.79L381.109 223.061L369.139 223.348L359.331 222.966L331.203 218.717L331.255 216.626Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M362.421 277.744C362.421 277.744 357.563 271.97 357.555 262.123C357.545 249.64 362.421 244.839 362.421 244.839H377.596C377.596 244.839 382.028 250.62 382.028 262.123C382.028 272.686 377.596 277.744 377.596 277.744H362.421Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M362.421 277.744C362.421 277.744 357.563 271.97 357.555 262.123C357.545 249.64 362.421 244.839 362.421 244.839H377.596C377.596 244.839 382.028 250.62 382.028 262.123C382.028 272.686 377.596 277.744 377.596 277.744H362.421Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M373.735 244.839H366.445V246.043H373.735V244.839Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M407.986 217.007H331.705V218.813H407.986V217.007Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M407.986 217.007H331.705V218.813H407.986V217.007Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M334.382 215.195H331.705V217.001H334.382V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M378.321 215.195H375.644V217.001H378.321V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M370.738 215.195H368.062V217.001H370.738V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M363.155 215.195H360.478V217.001H363.155V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M356.606 215.195H353.929V217.001H356.606V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M350.217 215.195H347.541V217.001H350.217V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M343.526 215.195H340.85V217.001H343.526V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M404.416 215.195H401.74V217.001H404.416V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M392.819 215.195H390.142V217.001H392.819V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M386.351 215.195H383.674V217.001H386.351V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M398.984 215.195H396.307V217.001H398.984V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M408.432 215.195H405.755V217.001H408.432V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M338.174 215.195H335.497V217.001H338.174V215.195Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M374.003 200.066H366.178V201.27H374.003V200.066Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M374.003 200.066H366.178V201.27H374.003V200.066Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M374.29 268.648H367V271.658H374.29V268.648Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M367.081 269.25H365.275V271.056H367.081V269.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M369.894 244.839V270.153",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M369.894 244.839V270.153",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M185.405 540.163V588.116",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M185.405 540.163V588.116",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M177.875 635.987L177.71 739.094L227.089 739.173L227.254 636.066L177.875 635.987Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M195.111 592.72V731.476H210.915L210.761 590.423",
    fill: "#131F2E"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M195.111 592.72V731.476H210.915L210.761 590.423",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 673.351H197.519V686.593H208.353V673.351Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 673.351H197.519V686.593H208.353V673.351Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M208.43 688.942H197.596V702.184H208.43V688.942Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M208.43 688.942H197.596V702.184H208.43V688.942Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 668.995H197.519V671.748H208.353V668.995Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 668.995H197.519V671.748H208.353V668.995Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M207.274 657.053H198.747V668.82H207.274V657.053Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M207.274 657.053H198.747V668.82H207.274V657.053Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 655.678H197.519V657.054H208.353V655.678Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 655.678H197.519V657.054H208.353V655.678Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M207.752 667.619H198.121V668.823H207.752V667.619Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M207.752 667.619H198.121V668.823H207.752V667.619Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M208.43 704.292H197.596V708.52H208.43V704.292Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M208.43 704.292H197.596V708.52H208.43V704.292Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M197.596 714.475V710.247H208.43V714.475L205.669 715.679H203.562L202.057 716.882L200.251 715.077L197.596 714.475Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M197.596 714.475V710.247H208.43V714.475L205.669 715.679H203.562L202.057 716.882L200.251 715.077L197.596 714.475Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.5
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M202.057 716.882L197.596 719.383L207.274 721.761L197.596 723.868L207.274 725.673L198.121 727.864",
    fill: "#131F2E"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M202.057 716.882L197.596 719.383L207.274 721.761L197.596 723.868L207.274 725.673L198.121 727.864",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M202.057 716.882L197.596 719.383L207.274 721.761L197.596 723.868L207.274 725.673L198.121 727.864",
    fill: "#131F2E"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M202.057 716.882L197.596 719.383L207.274 721.761L197.596 723.868L207.274 725.673L198.121 727.864",
    stroke: "#F7F9F9"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M207.277 728.45H198.75V731.424H207.277V728.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M207.277 728.45H198.75V731.424H207.277V728.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M207.829 727.848H198.198V729.052H207.829V727.848Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M207.829 727.848H198.198V729.052H207.829V727.848Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlungerLift);
export default __webpack_public_path__ + "static/media/plunger-lift.0445b7b2a4395bbafd5ea93bbbbed8b9.svg";
export { ForwardRef as ReactComponent };